/* eslint-disable max-len */
import React from 'react'
import Input from '../../InputBox';
import { useState ,useRef} from 'react';
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';
import CustomeDatePicker from '../../DatePicker';

export default function AddAcademicYear({academicState, setAddAcademicYearState,status,setResponseStatus,submitSelected,setsubmitSelected,onBlur,edit,originalEditDates,setActivateOpen,setToastErrorMessage}) {
    const [isAcademicYearStatus, setIsAcademicYearStatus] = useState(false);
    const [dateError, setdateError] = useState("");
    const academicRef = useRef();

    let StatusList=['Draft','Ongoing AY','Upcoming AY']
    if(edit && originalEditDates.original_status==='Ongoing AY'){
        StatusList=['Ongoing AY','Upcoming AY','Completed']
    }
    if(edit && originalEditDates.original_status==='Upcoming AY'){
        StatusList=['Ongoing AY','Upcoming AY','Completed']
    }

    /**
     * The function `handleInput` updates the `academic_year_name` property in the
     * `addAcademicYearState` object with the value of the input field.
     */
    const handleInput = (e) => {
        setToastErrorMessage('')
        setResponseStatus('')
        
        setAddAcademicYearState((prv)=>({
            ...prv,
            academic_year_name:e.target.value
        }));
    };
    
    /**
     * The function `handleStatusClick` updates the academic year status and performs additional
     * actions based on the selected status.
     */
    const handleStatusClick=(item)=>{
        setToastErrorMessage('')
        setIsAcademicYearStatus(false);
        setAddAcademicYearState((prv) => ({
            ...prv,
            academic_year_status: item,
        }));
        if(originalEditDates.original_status==='Draft'&& item!=='Draft'){
            setAddAcademicYearState((prv)=>({
                ...prv,
                start_date:originalEditDates.original_start_date,
                end_date:originalEditDates.original_end_date
            }))
        }
        if(item==="Completed"){
            setActivateOpen(true)
        }
        
    }
   
    /* The above code is using the `useOnClickOutside` hook in a React component. It is passing in a
    reference to an element (`academicRef`) and a callback function. The purpose of this hook is to
    detect when a click event occurs outside of the specified element, and then execute the callback
    function. In this case, when a click event occurs outside of the `academicRef` element, the
    `setIsAcademicYearStatus` function is called with the argument `false`, which presumably updates
    the state of the component. */
    useOnClickOutside(academicRef, () => {
        setIsAcademicYearStatus(false);
    });
    
    /**
     * The function `handleSelectStartDate` updates the `start_date` property in the
     * `addAcademicYearState` object with the selected date.
     */
    const handleSelectStartDate = (id,date,dateString,termkey) => {
        setResponseStatus('')
        setAddAcademicYearState((prv) => ({
            ...prv,
            start_date: dateString,
        }));
    };

    /**
     * The function `handleSelectEndDate` updates the `end_date` property in the `addAcademicYearState`
     * object with the selected date string.
     */
    const handleSelectEndDate = (id,date,dateString,termkey) => {
        setResponseStatus("");
        setAddAcademicYearState((prv) => ({
            ...prv,
            end_date: dateString,
        }));
    };
    return (
        <div class="mainDataCntnrPageDiv scrollBlue_thick">
            <div class="flex">
                <div class="xl:w-[70%] 2xl:w-[65%] mx-auto">
                    <div class="border border-[#D0D5DD] p-3 rounded">
                        <div class="flex -mx-10">
                            <div class="pl-10 w-1/2">
                                <div class="w-full mb-4">
                                    <div class="flex items-center mb-4">
                                        <label
                                            for="acadameicYearName"
                                            class="text-f7 font-normal text-[#031624] min-w-[170px] inline-flex"
                                        >
                                            Academic Year Name
                                        </label>
                                        <Input
                                            type="text"
                                            state={academicState}
                                            id="academic_year_name"
                                            test_id="academic_year_name"
                                            handleInput={handleInput}
                                            maxLength={30}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            showErrorBorder = {setsubmitSelected && status === "409"}
                                            isMandatoryField = {true}
                                            text="First name is mandatory"
                                            placeholder="Enter Year Name"
                                            disable={(edit&&academicState.academic_year_status==="Ongoing AY")||(edit&&academicState.academic_year_status==="Upcoming AY")}
                                        />
                                    </div>
                                </div>
                                <div class="flex items-center">
                                    <label
                                        htmlFor="bname"
                                        className="text-f7 font-normal text-[#031624] min-w-[170px] inline-flex"
                                    >
                                        Status
                                    </label>
                                    <div
                                        className="relative w-full"
                                        data-te-dropdown-ref
                                        ref={academicRef}
                                    >
                                        <button
                                            className={`slct-inpt-fld transition duration-150 ease-in-out shadow-s12`}
                                            style={{'padding-right':'30px'}}
                                            type="button"
                                            disabled={academicState.disable_status}
                                            onClick={() =>
                                                setIsAcademicYearStatus(!isAcademicYearStatus)
                                            }
                                            id="dropdownMenu_acdemic_year"
                                            data-te-dropdown-toggle-ref
                                            aria-expanded="false"
                                        >
                                            <p>
                                                {academicState.academic_year_status === "draft"
                                                    ? "Draft"
                                                    : academicState.academic_year_status}
                                            </p>
                                            <img
                                                src="/images/dropdown-icon.png"
                                                alt="icon"
                                                className={`absolute top-[50%] -translate-y-[50%] dropdown-close right-3 ${isAcademicYearStatus ? "transform rotate-180" : ""}`}
                                            />
                                        </button>
                                        {isAcademicYearStatus && 
                                            <ul
                                                className="slct_drp_dwn min-w-full [&amp;[data-te-dropdown-show]]:block"
                                                aria-labelledby="dropdownMenu_acdemic_year"
                                                data-te-dropdown-menu-ref
                                            >
                                                <li className="max-h-[150px] overflow-auto scroll-bar">
                                                    <ul>
                                                        {StatusList.map((item)=>(
                                                            <li key={item}>
                                                                <p
                                                                    onClick={()=>handleStatusClick(item)}
                                                                    class="slct_drp_dwn_optn">{item}</p>
                                                            </li>
                                                        ))}
                                                      
                                                    </ul>
                                            
                                                </li>
                                            </ul>}
                                    
                                    </div>
                                </div>
                            </div>
                            <div class="px-10 w-1/2" style={{'padding-left':'5rem'}}>
                                <div class="w-full">
                                    <div class="relative w-full flex items-center mb-4">
                                        <label
                                            for="startDate"
                                            class="text-f7 font-normal text-[#031624] min-w-[80px] inline-flex"
                                        >
                                            Start Date
                                        </label>
                                        <div class="relative w-full">
                                            <CustomeDatePicker
                                                id="start_date"
                                                showErrorBorder={(submitSelected &&
                                                    academicState.start_date === "") ||
                                                  ( status === "dateError")}
                                                format="MMM DD, YYYY"
                                                state={academicState}
                                                placeholder="Select Start Date"
                                                handleSelect={handleSelectStartDate}
                                                setdateError={setdateError}
                                                termkey={academicState.start_date}
                                                disabledDate={academicState.disable_start_date||(edit&&academicState.academic_year_status==="Ongoing AY")||(edit&&academicState.academic_year_status==="Upcoming AY")}
                                                imageClass={true}
                                                onBlur={onBlur}
                                            />
                                        </div>
                                    </div>
                                    <div class="relative w-full flex items-center">
                                        <label
                                            for="endDate"
                                            className="text-f7 font-normal text-[#031624] min-w-[80px] inline-flex"
                                        >
                                            End Date
                                        </label>

                                        <CustomeDatePicker
                                            id="end_date"
                                            showErrorBorder={(submitSelected && academicState.end_date === "") ||
                                                ( status === "dateError")}
                                            format="MMM DD, YYYY"
                                            state={academicState}
                                            placeholder="Select End Date"
                                            handleSelect={handleSelectEndDate}
                                            setdateError={setdateError}
                                            termkey={academicState}
                                            disabledDate={academicState.disable_end_date||(edit&&academicState.academic_year_status==="Ongoing AY")||(edit && academicState.academic_year_status==="Upcoming AY")}
                                            imageClass={true}
                                            onBlur={onBlur}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}